import { FirebaseApp, initializeApp, getApps, getApp } from 'firebase/app'
import { getDatabase } from 'firebase/database'

const {
  REACT_APP_FIREBASE_API_KEY,
  REACT_APP_FIREBASE_AUTH_DOMAIN,
  REACT_APP_FIREBASE_DATABASE_URL,
  REACT_APP_FIREBASE_STORAGE_BUCKET,
} = process.env

const firebaseConfig = {
  apiKey: REACT_APP_FIREBASE_API_KEY,
  authDomain: REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: REACT_APP_FIREBASE_DATABASE_URL,
  storageBucket: REACT_APP_FIREBASE_STORAGE_BUCKET,
} as const

export const initializeFirebase = () => {
  let app: FirebaseApp
  try {
    const firebaseApps: FirebaseApp[] = getApps()

    if (!firebaseApps.length) {
      app = initializeApp(firebaseConfig)
    } else {
      app = getApp()
    }
    const db = getDatabase(app)
    return db
  } catch {
    return null
  }
}
